<template>
  <label class="checkbox">
    <input type="checkbox"
           v-model="value"
           :id="id"
           :name="name"
           :checked="inputValue()" />
    <span class="mr-2"></span>
    {{$t(label)}}
  </label>
</template>

<script>
export default {
  props: {
    label: String,
    id: String | Number,
    name: String,
    defaultValue: { type: String, default: '' },
  },
  name: 'Checkbox',
  data() {
    return {
      value: false,
    }
  },
  created() {
    this.setValue()
  },
  methods: {
    setValue() {
      this.value =
        this.defaultValue == 'true' || this.defaultValue == true ? true : false
    },
    inputValue() {
      this.$emit('input', this.value)
    },
  },
  watch: {
    defaultValue(val) {
      this.setValue()
    },
  },
}
</script>